import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, message } from "antd";
import { firestore, storage } from "../../config/firebase";
import { v4 as uuidv4 } from "uuid";
import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import {
  collection,
  updateDoc,
  doc,
} from "firebase/firestore";

const AdvertisementModal = ({ isOpen, onClose, selectedUniversity }) => {
  const [form] = Form.useForm();
  const [selectedImage, setSelectedImage] = useState({ currentImg: "", newImg: "" });
  const [loading, setLoading] = useState(false);
  const [oldObject, setOldObject] = useState({ title: "", content: "" });

  useEffect(() => {
    if (selectedUniversity) {
      const { title, content, images } = selectedUniversity;
      form.setFieldsValue({ title, content });
      setOldObject({ title, content });
      setSelectedImage({ currentImg: images || "", newImg: "" });
    } else {
      form.resetFields();
      setOldObject({ title: "", content: "" });
      setSelectedImage({ currentImg: "", newImg: "" });
    }
  }, [selectedUniversity]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();

      const hasNoChanges =
        !selectedImage.newImg &&
        values.title === oldObject.title &&
        values.content === oldObject.content;

      if (hasNoChanges) {
        onClose();
        return;
      }

      setLoading(true);
      let remoteUrl = selectedImage.currentImg;

      if (selectedImage.newImg) {
        const oldImageRef = ref(storage, selectedImage.currentImg);
      await deleteObject(oldImageRef);
        const uniqueFilename = `${Date.now()}-${uuidv4()}`;
        const storageRef = ref(storage, `university/${uniqueFilename}`);
        await uploadBytes(storageRef, selectedImage.newImg);
        remoteUrl = await getDownloadURL(storageRef);
      }

      const university = {
        title: values.title,
        content: values.content,
        images: remoteUrl,
      };

      await updateDoc(doc(collection(firestore, "university"), selectedUniversity.id), university);

      message.success("University updated successfully");
      onClose();
    } catch (error) {
      console.error("Error saving post:", error);
      message.error("Failed to save university details");
    } finally {
      setLoading(false);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const extension = file.name.split(".").pop().toLowerCase();
    if (extension === "svg") {
      form.setFields([{ name: "image", errors: ["SVG image is not allowed"] }]);
      return;
    }

    form.setFields([{ name: "image", errors: [] }]);
    setSelectedImage((prev) => ({ ...prev, newImg: file }));
  };

  return (
    <Modal
      title="University"
      open={isOpen}
      onCancel={onClose}
      footer={null}
      getContainer={false}
    >
      <Form form={form} onFinish={handleSave} disabled={loading}>
        <Form.Item label="Title" name="title" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item label="Content" name="content" rules={[{ required: true }]}>
          <Input.TextArea />
        </Form.Item>

        <Form.Item label="Image" name="image">
          <input type="file" accept="image/*" onChange={handleImageChange} disabled={loading} />
        </Form.Item>

        {selectedImage.currentImg && (
          <div style={{ marginTop: 16 }}>
            <img
              key={selectedImage.currentImg}
              src={selectedImage.currentImg}
              alt="current"
              style={{ width: 100, height: 100, objectFit: "cover", borderRadius: 8 }}
            />
          </div>
        )}

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Save
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AdvertisementModal;
